var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "documents-actions",
      class: {
        "documents-actions-red":
          _vm.record.expired && _vm.tableType === "documents-acting-documents",
        "documents-actions-yellow":
          _vm.record.expireSoon &&
          _vm.tableType === "documents-acting-documents",
      },
    },
    [
      _c("m-create-edit-document", {
        attrs: {
          active: _vm.isShowEditDocumentModal,
          title: "Редактировать документ",
          "current-document-id": _vm.record.documentTypeId,
          "is-edit": true,
          "document-id": _vm.record.documentId,
          "attached-files": _vm.record.files.items,
          deadline: _vm.record.deadline.value,
          comment: _vm.record.comment,
        },
        on: {
          close: function ($event) {
            _vm.isShowEditDocumentModal = false
          },
        },
      }),
      _c(
        "div",
        { staticClass: "documents-actions-buttons" },
        [
          _vm.record.comment !== null && _vm.record.comment.length > 0
            ? _c("c-button", {
                directives: [
                  {
                    name: "b-popover",
                    rawName: "v-b-popover.html",
                    value: {
                      container: "#app",
                      trigger: "hover blur",
                      content: "Комментарий",
                      placement: "top",
                    },
                    expression:
                      "{\n        container: '#app',\n        trigger: 'hover blur',\n        content: 'Комментарий',\n        placement: 'top',\n      }",
                    modifiers: { html: true },
                  },
                ],
                staticClass: "documents-actions-comment",
                attrs: { size: "iconic", icon: "comment" },
                on: {
                  click: function ($event) {
                    _vm.isShowCommentModal = true
                  },
                },
              })
            : _vm._e(),
          _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "История изменений",
                  placement: "top",
                },
                expression:
                  "{\n        container: '#app',\n        trigger: 'hover blur',\n        content: 'История изменений',\n        placement: 'top',\n      }",
                modifiers: { html: true },
              },
            ],
            staticClass: "documents-actions-change-history",
            attrs: { size: "iconic", icon: "change-history" },
            on: {
              click: function ($event) {
                _vm.isShowHistoryChangesModal = true
              },
            },
          }),
          _c("c-button", {
            staticClass: "documents-actions-menu documents-actions-menu-active",
            attrs: {
              id: `c-table-actions-menu-${_vm.recordId}`,
              tabindex: "-1",
              size: "iconic",
              icon: "menu",
            },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          staticClass: "documents-actions-comment-modal",
          attrs: {
            id: "documents-actions-comment-modal",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
          },
          model: {
            value: _vm.isShowCommentModal,
            callback: function ($$v) {
              _vm.isShowCommentModal = $$v
            },
            expression: "isShowCommentModal",
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: { overflow: "hidden", "text-overflow": "ellipsis" },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "documents-actions-comment-modal-close",
                  attrs: {
                    width: "15",
                    height: "16",
                    viewBox: "0 0 15 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                  on: {
                    click: function ($event) {
                      _vm.isShowCommentModal = false
                    },
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                      fill: "#8E9CBB",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                      fill: "#8E9CBB",
                    },
                  }),
                ]
              ),
              _vm._v(" " + _vm._s(_vm.record.comment) + " "),
            ]
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          staticClass: "m-history-changes",
          attrs: {
            id: "documents-actions-history-changes-modal",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
          },
          on: { show: _vm.onShowHistoryChangesModal },
          model: {
            value: _vm.isShowHistoryChangesModal,
            callback: function ($$v) {
              _vm.isShowHistoryChangesModal = $$v
            },
            expression: "isShowHistoryChangesModal",
          },
        },
        [
          _c("div", [
            _c(
              "svg",
              {
                staticClass: "m-history-changes-close",
                attrs: {
                  width: "15",
                  height: "16",
                  viewBox: "0 0 15 16",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
                on: {
                  click: function ($event) {
                    _vm.isShowHistoryChangesModal = false
                  },
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                    fill: "#8E9CBB",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                    fill: "#8E9CBB",
                  },
                }),
              ]
            ),
            _c("div", { staticClass: "m-history-changes-title" }, [
              _vm._v("История изменений"),
            ]),
            _c("div", { staticClass: "position-relative" }, [
              _c("div", {
                staticClass: "m-history-changes-content-shadow-top",
                attrs: { id: "history-changes-shadow-top" },
              }),
              _c(
                "div",
                {
                  staticClass: "m-history-changes-content",
                  style: {
                    overflow: _vm.isLoadedHistoryChanges ? "hidden" : "",
                  },
                  attrs: { id: "m-history-changes-content" },
                  on: { scroll: _vm.setShadowHistoryChangesList },
                },
                [
                  _c(
                    "div",
                    { staticClass: "m-history-changes-content-list" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "m-history-changes-content-list-loader",
                        },
                        [
                          _vm.isLoadedHistoryChanges
                            ? _c("font-awesome-icon", {
                                attrs: { icon: _vm.icon, spin: "" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._l(
                        _vm.documentHistoryChangesItems,
                        function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass:
                                "m-history-changes-content-list-item",
                            },
                            [
                              !_vm.isLoadedHistoryChanges &&
                              _vm.documentHistoryChangesItems.length > 0
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "m-history-changes-content-list-item-time",
                                      },
                                      [_vm._v(_vm._s(item.date))]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "m-history-changes-content-list-item-username",
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "m-history-changes-content-list-item-status",
                                      },
                                      [_vm._v(" " + _vm._s(item.status))]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        }
                      ),
                      !_vm.isLoadedHistoryChanges &&
                      _vm.documentHistoryChangesItems.length === 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "m-history-changes-content-list-empty",
                            },
                            [_vm._v(" Нет результатов ")]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _c("div", {
                staticClass: "m-history-changes-content-shadow-bottom",
                attrs: { id: "history-changes-shadow-bottom" },
              }),
            ]),
          ]),
        ]
      ),
      _c(
        "b-popover",
        {
          ref: "popover",
          attrs: {
            id: `document-actions-menu-popover`,
            placement: "bottomleft",
            triggers: "click blur",
            target: `c-table-actions-menu-${_vm.recordId}`,
          },
        },
        [
          _c("div", { staticClass: "documents-actions-menu-popover" }, [
            _vm.userHavePermissionAddEditDocument() &&
            _vm.tableType === "documents-acting-documents"
              ? _c(
                  "div",
                  {
                    staticClass: "documents-actions-menu-popover-item",
                    on: {
                      click: function ($event) {
                        _vm.isShowEditDocumentModal = true
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "documents-actions-menu-popover-item-icon",
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 14 14",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M9.33943 1.62805L8.63232 0.920947L8.63232 0.920948L9.33943 1.62805ZM10.8557 1V0V1ZM13 3.14431H14H13ZM12.3719 4.66057L11.6648 3.95346L11.6648 3.95346L12.3719 4.66057ZM5.16971 11.8628L5.43283 12.8276C5.60073 12.7818 5.75376 12.693 5.87682 12.5699L5.16971 11.8628ZM1 13L0.0352364 12.7369C-0.0591854 13.0831 0.0391427 13.4534 0.292893 13.7071C0.546642 13.9609 0.916904 14.0592 1.26312 13.9648L1 13ZM2.13719 8.8303L1.43009 8.12319C1.30703 8.24625 1.21822 8.39929 1.17243 8.56718L2.13719 8.8303ZM10.0465 2.33516C10.1528 2.2289 10.2789 2.14461 10.4178 2.08711L9.65241 0.239346C9.27093 0.397362 8.9243 0.62897 8.63232 0.920947L10.0465 2.33516ZM10.4178 2.08711C10.5566 2.0296 10.7054 2 10.8557 2V0C10.4428 0 10.0339 0.0813298 9.65241 0.239346L10.4178 2.08711ZM10.8557 2C11.006 2 11.1548 2.0296 11.2936 2.08711L12.059 0.239346C11.6775 0.0813296 11.2686 0 10.8557 0V2ZM11.2936 2.08711C11.4324 2.14461 11.5586 2.2289 11.6648 2.33516L13.0791 0.920947C12.7871 0.628971 12.4404 0.397363 12.059 0.239346L11.2936 2.08711ZM11.6648 2.33516C11.7711 2.44142 11.8554 2.56757 11.9129 2.7064L13.7607 1.94103C13.6026 1.55955 13.371 1.21292 13.0791 0.920947L11.6648 2.33516ZM11.9129 2.7064C11.9704 2.84523 12 2.99403 12 3.14431H14C14 2.7314 13.9187 2.32252 13.7607 1.94103L11.9129 2.7064ZM12 3.14431C12 3.29459 11.9704 3.44339 11.9129 3.58222L13.7607 4.34759C13.9187 3.9661 14 3.55722 14 3.14431H12ZM11.9129 3.58222C11.8554 3.72105 11.7711 3.8472 11.6648 3.95346L13.0791 5.36768C13.371 5.0757 13.6026 4.72907 13.7607 4.34759L11.9129 3.58222ZM11.6648 3.95346L4.46261 11.1557L5.87682 12.5699L13.0791 5.36767L11.6648 3.95346ZM4.9066 10.898L0.736884 12.0352L1.26312 13.9648L5.43283 12.8276L4.9066 10.898ZM1.96476 13.2631L3.10196 9.09342L1.17243 8.56718L0.0352364 12.7369L1.96476 13.2631ZM2.8443 9.53741L10.0465 2.33516L8.63232 0.920948L1.43009 8.12319L2.8443 9.53741ZM7 4L10 7L11.4142 5.58579L8.41421 2.58579L7 4Z",
                                fill: "#8E9CBB",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "documents-actions-menu-popover-item-label",
                      },
                      [_vm._v("Редактировать")]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.record.files.items !== null && _vm.record.files.items.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "documents-actions-menu-popover-item",
                    on: { click: _vm.downloadArchiveDocument },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "documents-actions-menu-popover-icon" },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 16 16",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M4.70711 6.29289C4.31658 5.90237 3.68342 5.90237 3.29289 6.29289C2.90237 6.68342 2.90237 7.31658 3.29289 7.70711L4.70711 6.29289ZM7 10L6.29289 10.7071C6.68342 11.0976 7.31658 11.0976 7.70711 10.7071L7 10ZM10.7071 7.70711C11.0976 7.31658 11.0976 6.68342 10.7071 6.29289C10.3166 5.90237 9.68342 5.90237 9.29289 6.29289L10.7071 7.70711ZM8 1C8 0.447715 7.55228 0 7 0C6.44772 0 6 0.447715 6 1H8ZM14 10C14 9.44771 13.5523 9 13 9C12.4477 9 12 9.44771 12 10H14ZM2 10C2 9.44771 1.55228 9 1 9C0.447715 9 0 9.44771 0 10H2ZM3.29289 7.70711L6.29289 10.7071L7.70711 9.29289L4.70711 6.29289L3.29289 7.70711ZM7.70711 10.7071L10.7071 7.70711L9.29289 6.29289L6.29289 9.29289L7.70711 10.7071ZM8 10V1H6V10H8ZM12 10V12H14V10H12ZM12 12H2V14H12V12ZM2 12V10H0V12H2ZM2 12H2H0C0 13.1046 0.895431 14 2 14V12ZM12 12V14C13.1046 14 14 13.1046 14 12H12Z",
                                fill: "#8E9CBB",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "documents-actions-menu-popover-item-label",
                      },
                      [_vm._v("Скачать")]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.userHavePermissionMoveDocumentInArchive() &&
            (_vm.tableType === "documents-acting-documents" ||
              _vm.tableType === "documents-archive")
              ? _c(
                  "div",
                  {
                    staticClass: "documents-actions-menu-popover-item",
                    on: { click: _vm.changeArchiveStatusSingle },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "documents-actions-menu-popover-item-icon",
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "17",
                              height: "15",
                              viewBox: "0 0 17 15",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M1 5H0V6H1V5ZM16 5V6H17V5H16ZM2 5V4H1V5H2ZM15 5H16V4H15V5ZM7 7C6.44772 7 6 7.44772 6 8C6 8.55228 6.44772 9 7 9V7ZM10 9C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7V9ZM14.5003 0H2.4997V2H14.5003V0ZM2.4997 0C1.12273 0 0 1.11598 0 2.49575H2C2 2.22552 2.22232 2 2.4997 2V0ZM0 2.49575V5H2V2.49575H0ZM17 5V2.49575H15V5H17ZM17 2.49575C17 1.11598 15.8773 0 14.5003 0V2C14.7777 2 15 2.22552 15 2.49575H17ZM1 6H16V4H1V6ZM13.4997 13H3.50031V15H13.4997V13ZM3.50031 13C3.22221 13 3 12.7741 3 12.5043H1C1 13.8844 2.12339 15 3.50031 15V13ZM3 12.5043V5H1V12.5043H3ZM14 5V12.5043H16V5H14ZM14 12.5043C14 12.7741 13.7778 13 13.4997 13V15C14.8766 15 16 13.8844 16 12.5043H14ZM2 6H15V4H2V6ZM7 9H10V7H7V9Z",
                                fill: "#8E9CBB",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm.tableType === "documents-acting-documents"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "documents-actions-menu-popover-item-label",
                          },
                          [_vm._v("Переместить в архив")]
                        )
                      : _vm._e(),
                    _vm.tableType === "documents-archive"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "documents-actions-menu-popover-item-label",
                          },
                          [_vm._v("Восстановить из архива")]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }